// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const melmetal_gmax: PokeData = {
  "id": 10208,
  "name": "melmetal-gmax",
  "height": 250,
  "weight": 10000,
  "base_experience": 270,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [],
  "moves": [
    "scrap-throw",
    "meteor-mash",
    "steel-beam",
    "metal-claw",
    "metal-sound",
    "smart-strike",
    "magnet-bomb",
    "metal-burst",
    "behemoth-bash"
  ],
  "evolution_chain": {
    "id": 429,
    "item": null,
    "species": [
      {
        "name": "melmetal",
        "order": 809,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 808,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 161,
    "speed": 46,
    "ability_power": 193
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
